import React from "react";
import TypographyArabic from "../../../../../SharedComponents/TypographyArabic.jsx";

/**
 * Простое форматирование текста: поддерживает **жирный**, //курсив// и их комбинации.
 * Состояние жирного/курсива передаётся снаружи, чтобы сохранять его между сегментами и строками.
 * @param {string} text
 * @param {{ bold: boolean, italic: boolean }} state
 * @returns {{ nodes: React.ReactNode[], bold: boolean, italic: boolean }}
 */
const formatTextSegment = (text, state) => {
  // Преобразуем строку с управляющими символами в набор React-элементов
  const result = [];
  let buffer = "";
  // Начальное состояние форматирования приходит снаружи
  let bold = state?.bold ?? false;
  let italic = state?.italic ?? false;
  let keyIndex = 0;

  /**
   * Сбрасывает накопленный текст из buffer в массив result
   * с учётом текущего состояния жирного/курсива.
   */
  const pushBuffer = () => {
    if (!buffer) return;
    // Оборачиваем *внутренний* strong/em в TypographyArabic, чтобы его стили не перебивались
    let inner = buffer;

    if (bold && italic) {
      inner = (
        <strong>
          <em>{buffer}</em>
        </strong>
      );
    } else if (bold) {
      inner = <strong>{buffer}</strong>;
    } else if (italic) {
      inner = <em>{buffer}</em>;
    }

    const content = (
      <TypographyArabic key={keyIndex} component="span">
        {inner}
      </TypographyArabic>
    );

    result.push(content);

    keyIndex += 1;
    buffer = "";
  };

  for (let i = 0; i < text.length; i += 1) {
    if (text[i] === "*" && text[i + 1] === "*") {
      pushBuffer();
      bold = !bold;
      i += 1;
    } else if (text[i] === "/" && text[i + 1] === "/") {
      pushBuffer();
      italic = !italic;
      i += 1;
    } else {
      buffer += text[i];
    }
  }

  pushBuffer();

  return { nodes: result, bold, italic };
};

export default formatTextSegment;
